/* FloorEver — Hero « La promesse » (sections/floorever-hero.liquid).
 *
 * Amélioration progressive : si la photo ne se charge pas (URL cassée), on
 * la masque pour laisser l'aplat de repli de .hero-media ; dès qu'une autre
 * taille du srcset se charge (redimensionnement, passage mobile/ordinateur),
 * on la réaffiche. Avant le 17/10/2026, une seule erreur masquait la photo
 * pour de bon, même quand une autre taille arrivait ensuite.
 *
 * Réinitialisé sur shopify:section:load (éditeur de thème).
 *
 * Hook : conteneur [data-hero-media] (classe d'état .is-vide).
 */
(function () {
  'use strict';

  function initMedia(scope) {
    var media = scope.querySelector('[data-hero-media]');
    var img = media && media.querySelector('img');
    if (!img) return;

    function etat() {
      media.classList.toggle('is-vide', img.complete && img.naturalWidth === 0);
    }

    img.addEventListener('error', etat);
    img.addEventListener('load', etat);
    // Photo déjà chargée (ou déjà en erreur) avant l'attache des écouteurs.
    etat();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initMedia(document);
    });
  } else {
    initMedia(document);
  }

  // Éditeur de thème : ré-initialiser quand la section est (re)chargée.
  document.addEventListener('shopify:section:load', function (event) {
    initMedia(event.target);
  });
})();
